import { render, staticRenderFns } from "./CustomService.vue?vue&type=template&id=529e2282&"
import script from "./CustomService.vue?vue&type=script&lang=js&"
export * from "./CustomService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports